import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const BranchDetailsSkeleton = () => {
    const divs = Array.from({ length: 6 }, (_, index) => (
        <div className="my-2 row" key={index}>
            <div className="col-2 me-5">
                <Skeleton variant="rectangular" width={200} height={40} />
            </div>
            <div className="col-2">
                <Skeleton variant="rectangular" width={200} height={40} />
            </div>
        </div>

    ));

    return (
        <>
            <div className="col-2 me-5 mt-5 mb-3">
                <Skeleton variant="rectangular" width={200} height={40} />
            </div>
            <div className="mb-4">{divs}</div>
        </>

    );
}

export default BranchDetailsSkeleton;